import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { faCcVisa, faCcMastercard, faCcAmex } from "@fortawesome/free-brands-svg-icons";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import axios from "axios";

const SubscriptionPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedPlan } = location.state || {};
  const { email } = location.state || {};
  const [cardHolderName, setCardHolderName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const [user, setUser] = useState(null); // Initialize as null

  const handlePrev = () => {
    navigate("/personal-info", { state: { selectedPlan } });
  };

  const fetchUser = async (email) => {
    try {
      const response = await axios.get(
        `https://api.theonlysale.com/api/user/get/email/${email}`
      );
      setUser(response.data);
    } catch (error) {
      console.error("Error fetching user:", error);
    }
  };

  useEffect(() => {
    if (email) {
      fetchUser(email);
    }
  }, [email]);

  const handleCreditCardSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (!stripe || !elements) {
      console.error("Stripe or Elements not initialized");
      setIsSubmitting(false);
      return;
    }

    const cardElement = elements.getElement(CardElement);
    const { paymentMethod, error } = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
    });
    console.log("Payment Method:", paymentMethod);
    
    if (error) {
      console.error("Error creating payment method:", error);
      setIsSubmitting(false);
      return;
    }

    console.log(user)
    console.log(selectedPlan)

   const response = await fetch("https://api.theonlysale.com/api/subscriptions/post", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    paymentMethodId: paymentMethod.id,
    selectedPlan: selectedPlan.priceId, // This should be the Stripe price ID
    user_id: user.user_id,
  })
  
});

console.log("Response status:", response.status);

    const data = await response.json();

    if (response.ok) {
      try {
        const verificationResponse = await fetch(
          "https://api.theonlysale.com/api/send-verification",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: user.email }),
          }
        );

        if (verificationResponse.ok) {
          navigate("/verification", { state: { selectedPlan, email } });
        } else {
          console.error("Failed to send verification email");
        }
      } catch (verificationError) {
        console.error("Error sending verification email:", verificationError);
      }
    } else {
      console.error("Error with subscription:", data.message);
    }

    setIsSubmitting(false);
  };

  return (
    <>
      <Header />
      <div className="min-h-screen p-5 flex items-center justify-center bg-white dark:bg-gray-900">
        <div className="flex flex-col md:flex-row bg-white rounded-lg shadow-lg overflow-hidden w-full md:max-w-4xl">
          <div className="bg-blue-600 p-8 flex flex-col justify-between text-white w-full md:w-1/3 dark:bg-blue-800">
            <div>
              <h2 className="text-2xl md:text-3xl font-semibold mb-6">
                Your selected plan
              </h2>
              {selectedPlan ? (
                <>
                  <h3 className="text-xl md:text-2xl font-bold">
                    {selectedPlan.title}
                  </h3>
                  <p className="text-lg">{selectedPlan.price}/month</p>
                  <ul className="mt-4 space-y-2">
                    {selectedPlan.features.map((feature, index) => (
                      <li key={index} className="flex items-center">
                        <FontAwesomeIcon
                          icon={faCheck}
                          className="w-6 h-6 mr-2"
                        />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                <p>No plan selected.</p>
              )}
            </div>
          </div>

          <div className="bg-white w-full md:w-2/3 p-6 md:p-12 flex flex-col justify-between dark:bg-gray-800">
            <div className="space-y-6">
              <div className="flex flex-wrap items-center justify-between">
                {" "}
                <div className="flex items-center text-lg font-semibold text-blue-600 dark:text-blue-400">
                  <FontAwesomeIcon icon={faCheck} className="mr-2" />
                  Personal Info
                </div>
                <div className="flex items-center text-lg font-semibold text-blue-600 dark:text-blue-400">
                  <FontAwesomeIcon icon={faCheck} className="mr-2" />
                  Account Info
                </div>
                <div className="text-lg font-semibold text-gray-800 dark:text-gray-200">
                  3 Payment
                </div>
                <div className="text-lg font-semibold text-gray-800 dark:text-gray-200">
                  4 Confirmation
                </div>
              </div>

              <div className="space-y-6">
                <h3 className="text-2xl font-semibold mb-4 text-black dark:text-white">
                  Subscription Payment (CHF)
                </h3>
           
              <form onSubmit={handleCreditCardSubmit} className="space-y-4">
                <div className="mb-4 flex justify-center space-x-6">
                  <FontAwesomeIcon icon={faCcVisa} className="text-4xl text-blue-600" />
                  <FontAwesomeIcon icon={faCcMastercard} className="text-4xl text-red-600" />
                  <FontAwesomeIcon icon={faCcAmex} className="text-4xl text-blue-500" />
                </div>
                <div className="flex flex-col">
                  <label className="text-gray-800 dark:text-gray-200">
                    Cardholder's Name
                  </label>
                  <input
                    type="text"
                    value={cardHolderName}
                    onChange={(e) => setCardHolderName(e.target.value)}
                    placeholder="John Doe"
                    className="p-2 mt-1 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-blue-500 focus:border-blue-500"
                    required
                  />
                </div>

                <CardElement
                  className="mt-4 border p-3 rounded-lg border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800"
                  options={{
                    style: {
                      base: {
                        color: "#2c2c2c",
                        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                        fontSize: "18px",
                        "::placeholder": { color: "#a0a0a0" },
                      },
                      invalid: {
                        color: "#fa755a",
                        iconColor: "#fa755a",
                      },
                    },
                  }}
                />

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`mt-6 w-full p-3 text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition duration-200 ${
                    isSubmitting ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                >
                  {isSubmitting ? "Processing..." : "Subscribe"}
                </button>
              </form>
            </div>
          </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SubscriptionPage;
